module.exports = __webpack_public_path__ + "static/media/C02FCB4E-0988-4A64-8C5A-09D80E358025.8a62b062.jpeg";